import styled from 'styled-components';
import { media } from '../../../styles/media';
import layout from '../../../theme/layout';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 215px;

  ${media.desktop`
    max-width: ${layout.width}px;
  `};
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 100% ${media.desktop`
    max-width: 75%;
  `};
`;
